import * as React from "react";
import { observer } from "mobx-react";
import { Container, InstrumentIcon } from "./Logotype.styled";
import { getIconInstrument } from "../../../../helpers";
import { useStores } from "../../../../stores";
import { getGrandChartRoute } from "../../../../helpers/grandChart/grandChart.helper";
import { useLocation, useNavigate } from "react-router-dom";

export const Logotype = observer(() => {
	const { lessonStore, grandCharts } = useStores();
	const { grand_chart_group_lesson } = lessonStore;
	const { selected } = grandCharts;

	const location = useLocation();
	const navigate = useNavigate();

	console.log("selected", selected);

	const handleOnOpenGrandChart = async () => {
		console.log("lessonStore", lessonStore);

		navigate(
			getGrandChartRoute(
				location.pathname,
				grand_chart_group_lesson.grand_chart_id,
				grand_chart_group_lesson.grand_chart_course_id,
				grand_chart_group_lesson.grand_chart_module_id,
				grand_chart_group_lesson.id,
			),
		);

		// Регистрируем выбранный гранд чарт
		grandCharts.setSelected(selected);

		// Открываем гранд чарт
		grandCharts.modal.open();
	};

	return (
		<Container onClick={handleOnOpenGrandChart}>
			<InstrumentIcon>
				{getIconInstrument(lessonStore.grand_chart_group_lesson.grand_chart_current.instrument.slug, true)}
			</InstrumentIcon>
		</Container>
	);
});
